module.exports = __webpack_public_path__ + "static/anonymity-56ffc97e34eec52207cc85dbb0bd8a8b.jpg";